export default "__VITE_ASSET__Deh8eRDC__"